/* eslint-disable max-len */
import axios from 'axios';
import get from 'lodash/get';
import config from '../config';
import toCamelCase from '../utils/camelCase';
import {
  APP_ACTION_CREATE_CONFIGURATION_FAILED,
  logNewRelicError
} from '../utils/newRelicActions';

function createConfigurationPayload(selections, storeId, mainImageUrl, additionalDetails, totalPrice, productId = null) {
  const siteId = window?.__EXPERIENCE_PROPS__?.expConfiguration?.['site-id'];
  const payload = {
    siteId,
    productId,
    selections: selections.map((selection) => ({
      optionId: selection.optionId,
      choiceValue: selection.choiceId,
      choiceName: selection.choiceValue,
      optionTags: selection.optionTags,
    })),
    additionalDetails: additionalDetails && JSON.stringify(additionalDetails),
    storeId,
    mainImageUrl,
    baseCost: Number(totalPrice),
    basePrice: Number(totalPrice),
    isExternallyPriced: true,
  };
  if (productId) { payload.productId = productId; }
  return payload;
}

export const createConfiguration = (selections, storeId, mainImageUrl, additionalDetails, totalPrice, productId) => {
  const payload = createConfigurationPayload(selections, storeId, mainImageUrl, additionalDetails, totalPrice, productId);
  const url = window?.__EXPERIENCE_PROPS__?.expConfiguration?.['configurations-api-url'];
  return axios.post(url, payload)
    .then((response) => toCamelCase(response))
    .catch((error) => {
      logNewRelicError(APP_ACTION_CREATE_CONFIGURATION_FAILED, url, get(error, 'status', 500), url, payload);
      throw new Error(`API ERROR in ${url} ===>`, error);
    });
};

export const editConfiguration = (selections, storeId, mainImageUrl, additionalDetails, totalPrice) => {
  const payload = createConfigurationPayload(selections, storeId, mainImageUrl, additionalDetails, totalPrice);
  const url = `${config().configApiUrl}/api/v1/Configuration/Edit/`;
  const promise = axios.post(url, payload);
  return promise.then((response) => toCamelCase(response));
};

export const executeRules = (selectionData) => {
  const eleanorBaseUrl = window?.__EXPERIENCE_PROPS__?.expConfiguration?.['eleanor-base-url'];
  const url = `${eleanorBaseUrl}/catalog/productconfiguration/ExecuteRulesViaPost`;

  const promise = axios({
    data: selectionData,
    url,
    method: 'POST',
    crossDomain: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return promise.then((response) => toCamelCase(response)); // intentional. for use by configurator
};
